import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  effect,
  OnDestroy,
  OnInit,
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import {
  CreditCardDirectivesModule,
  CreditCardValidators,
} from "angular-cc-library";

import { Subscription } from "rxjs";
import { CartsService } from "../../../shared/services/carts.service";

import { CommonModule } from "@angular/common";
import { NgbModal, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { LaddaModule } from "angular2-ladda";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";
import swal from "sweetalert2";
import {
  API_URLS,
  FILE_PATH_CAGE,
  FILE_PATH_PLAN,
  PRODUCT_PATH,
} from "../../../config/app.constants";
import { OutPostModalService } from "../../../shared/header/outpost-list-modal/out-post-modal.service";
import { OutpostListModalComponent } from "../../../shared/header/outpost-list-modal/outpost-list-modal.component";
import { HttpinterceptorService } from "../../../shared/services/httpinterceptor.service";
import { Utils } from "../../../shared/utils";
import { CageBookingModalComponent } from "../health-map-reports/cage-booking-modal/cage-booking-modal.component";
import { GroomingPlanModalComponent } from "../health-map-reports/grooming-plan-modal/grooming-plan-modal.component";
declare var $: any;

@Component({
  selector: "app-checkout",
  templateUrl: "./checkout.component.html",
  styleUrls: ["./checkout.component.scss"],
  standalone: true,
  imports: [
    RouterLink,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    NgxTrimDirectiveModule,
    CreditCardDirectivesModule,
    LaddaModule,
    NgbTooltip,
    GroomingPlanModalComponent,
    CageBookingModalComponent,
    OutpostListModalComponent,
  ],
})
export class CheckoutComponent implements OnInit, OnDestroy, AfterViewChecked {
  private subscription: Subscription;

  isCardAdding: boolean = false;
  isPayment: boolean = false;
  addNewCard: boolean = true;
  submittedNewCard: boolean = false;
  card: string = "";
  cardType: string;
  cardList = [];
  cartDetails: any = { items: [] };
  interval: any;
  advanceSelectedPlan: any;
  updatedAmount: any;

  minimumPaymentFlag: boolean = false;
  maximumPaymentFlag: boolean = false;

  cartProcess: boolean = false;
  cartHasError: boolean = false;
  is_advance_amount: boolean = true;

  groomingPetDetail: any;
  groomingPlanDetail: any;
  showGroomingModal: boolean = false;

  boardingPetDetail: any;
  boardingPlanDetail: any;
  showBoardingModal: boolean = false;
  isChangeClinic = false;

  addCardFormData: any = {
    cc_exp_month: "",
    cc_exp_year: "",
    cc_csc: "",
    cc_number: "",
    cc_holder_name: "",
    // is_default: "",
  };
  addCreditCardForm = new FormGroup({
    cc_holder_name: new FormControl("", [Validators.required]),
    card_number: new FormControl("", [
      Validators.required,
      CreditCardValidators.validateCCNumber,
    ]),
    card_expiry: new FormControl("", [
      Validators.required,
      CreditCardValidators.validateExpDate,
    ]),
    card_cvv: new FormControl("", [Validators.minLength(3)]),
    // is_default: new FormControl(false, []),
  });
  selectedOutpostId;
  selectedOutpost;
  isItemNotRelatedSelectedoutpost = false;
  currentCheckoutItem;
  apiParams = {};
  selectedCartItem: any;
  filePath: string = FILE_PATH_PLAN;
  imagePath = {
    product: PRODUCT_PATH,
    cage: FILE_PATH_CAGE,
    subscription: FILE_PATH_PLAN,
  };

  constructor(
    private router: Router,
    private http: HttpinterceptorService,
    private cartService: CartsService,
    private modalService: NgbModal,
    private outpostModalService: OutPostModalService,
    private cdr: ChangeDetectorRef
  ) {
    this.cartDetails = JSON.parse(this.cartService.getCartItems());
    this.isItemNotRelatedSelectedoutpost = false;
    for (const item in this.cartDetails.items) {
      this.checkSelectedOutpostItem(item);
    }

    effect(() => {
      const el = this.outpostModalService.activatedPlan();
      if (el) {
        this.modalService.dismissAll();

        if (localStorage.getItem("selectedOutpostId")) {
          this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
        }
        this.isItemNotRelatedSelectedoutpost = false;

        for (const item in this.cartDetails.items) {
          this.checkSelectedOutpostItem(item);
        }
      }
    });
  }

  ngOnInit() {
    this.getCardList();

    // this.currentCheckoutItem = this.outpostModalService.currentPlan.subscribe(
    //   (el: any) => {
    //     if (el) {
    //       this.modalService.dismissAll();

    //       if (localStorage.getItem("selectedOutpostId")) {
    //         this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    //       }
    //       this.isItemNotRelatedSelectedoutpost = false;

    //       for (const item in this.cartDetails.items) {
    //         this.checkSelectedOutpostItem(item);
    //       }
    //     }
    //   }
    // );

    this.subscription = this.cartService.cartItems.subscribe((cartItems) => {
      this.cartDetails = JSON.parse(cartItems);
    });

    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }
    this.isItemNotRelatedSelectedoutpost = false;

    for (const item in this.cartDetails.items) {
      this.checkSelectedOutpostItem(item);
    }
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  getTotalCartPrice() {
    let totalPriceToShow = 0;
    this.isItemNotRelatedSelectedoutpost = false;

    for (const index in this.cartDetails.items) {
      if (this.cartDetails.items[index].error_message) {
        this.cartHasError = true;
      }
      this.checkSelectedOutpostItem(index);

      if (Object.prototype.hasOwnProperty.call(this.cartDetails.items, index)) {
        let itemType = this.cartDetails.items[index].item_type;
        if (itemType == "grooming" || itemType == "boarding") {
          totalPriceToShow += this.cartDetails.items[index].advance_payment;
        } else if (itemType == "subscription") {
          totalPriceToShow += this.getPriceTotal(
            this.cartDetails.items[index].plan_level.monthly_price,
            this.cartDetails.items[index].extra_services
          );
        } else {
          totalPriceToShow += this.cartDetails.items[index].price;
        }
      }
    }
    return totalPriceToShow;
  }

  getCardList() {
    this.http.post(API_URLS.GET_CARD, {}, false).subscribe(
      (res) => {
        if (res.code == "200" && res.type === "success") {
          this.cardList = res.data;
          if (res.data.length === 1 || res.data.length > 1) {
            this.card = this.cardList[0].id;
          } else if (res.data.length === 0) {
            this.card = "1";
            this.changeCard(this.card);
          } else {
            this.card = "1";
          }
        }
      },
      (error) => {
        return false;
      }
    );
  }

  addCreditCard() {
    this.submittedNewCard = true;
    if (this.addCreditCardForm.valid) {
      this.isCardAdding = true;
      const month = this.addCreditCardForm.value.card_expiry.split("/");
      this.addCardFormData.cc_number =
        this.addCreditCardForm.value.card_number.replace(/\s/g, "");
      this.addCardFormData.cc_exp_month = $.trim(month[0]);
      this.addCardFormData.cc_exp_year = $.trim(month[1]);
      this.addCardFormData.cc_csc = this.addCreditCardForm.value.card_cvv;
      this.addCardFormData.cc_holder_name =
        this.addCreditCardForm.value.cc_holder_name;
      /*  this.addCardFormData.is_default =
        this.addCreditCardForm.value.is_default  ? 1 : 0;
 */
      this.http.post(API_URLS.ADD_CARD, this.addCardFormData, true).subscribe(
        (res) => {
          this.isCardAdding = false;
          if (res.code == "200" && res.type === "success") {
            if (res.data) {
              this.card = res.data.id;
              this.addCreditCardForm.reset();
              this.addNewCard = true;
              this.getCardList();
            }
          }
        },
        (error) => {
          this.isCardAdding = false;
          return false;
        }
      );
    } else {
      return false;
    }
  }

  makePayment(cardDetails) {
    if (cardDetails) {
      this.isPayment = true;
      this.http
        .post(
          API_URLS.CHECKOUT,
          { card_id: cardDetails, out_post_id: this.selectedOutpostId },
          true
        )
        .subscribe(
          (res) => {
            this.isPayment = false;
            if (res.type === "success" && res.code === 200) {
              this.cartService.getCartWithApi();
              this.router.navigate(["/orders"]);
            }
          },
          (error) => {
            this.isPayment = false;
            return false;
          }
        );
    } else {
      return false;
    }
  }

  removeItemFromCart(id) {
    if (this.interval) {
      clearInterval(this.interval);
    }
    swal
      .fire({
        title: "Are you sure?",
        text: "You Want to Remove This Item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Remove it!",
        cancelButtonText: "No, keep it",
      })
      .then((result) => {
        if (result.value) {
          this.removeCartItem(id);
        }
      });
  }

  removeCartItem(itemId) {
    if (itemId) {
      this.cartService.removeItemApi(itemId);
    }
    // this.cartService.getCartWithApi();
    setTimeout(() => {
      this.cartDetails = JSON.parse(this.cartService.getCartItems());

      this.isItemNotRelatedSelectedoutpost = false;
      for (const item in this.cartDetails.items) {
        this.checkSelectedOutpostItem(item);
      }
    }, 2000);
  }

  getPriceTotal(planPrice, services) {
    let totalPrice = 0;
    for (const index in services) {
      if (Object.prototype.hasOwnProperty.call(services, index)) {
        totalPrice = totalPrice + services[index].monthly_price;
      }
    }
    return (totalPrice = planPrice + totalPrice);
  }

  changeCard(cardId) {
    if (cardId != "1" && cardId != "") {
      this.cancelNewCard();
    } else if (cardId == "1") {
      this.addCardForm();
    }
  }

  addCardForm() {
    this.submittedNewCard = false;
    this.addCreditCardForm.reset();
    this.addNewCard = false;
  }

  cancelNewCard() {
    if (this.cardList.length === 1) {
      this.addNewCard = true;
      this.card = this.cardList[0].id;
    } else if (this.cardList.length > 1) {
      this.addNewCard = true;
    }
  }

  editCartItem(cartData, serviceType) {
    switch (serviceType) {
      case "subscription":
        // sessionStorage.setItem('edit', 'true');
        // sessionStorage.setItem('edit_id', cartData.id);
        const cartUniqueId = cartData.cart_unique_id
          ? cartData.cart_unique_id
          : cartData.id;

        this.router.navigate([
          `plans/edit/${cartData.plan.slug}/${cartUniqueId}`,
        ]);
        break;

      case "grooming":
        this.isChangeClinic = false;
        this.openGroomingPlanModal(cartData);
        break;

      case "boarding":
        this.openBoardingModal(cartData);
        break;
    }
    Utils.disableBodyScroll();
  }

  // Grooming Plan Edit Modal
  openGroomingPlanModal(planDetail) {
    this.groomingPetDetail = {
      id: planDetail.pet_id,
      pet_size_id: planDetail.pet_size_id ? planDetail.pet_size_id : null,
    };
    this.groomingPlanDetail = {
      id: planDetail.grooming_plan_id,
      extraServices: planDetail.addon_detail,
      groomingDate: planDetail.groomingDate,
      groomer: planDetail.groomer_detail,
      cart_id: planDetail.id,
      is_advance_grooming_amount: planDetail.is_advance_grooming_amount,
      advance_payment: planDetail.advance_payment,
      planEditMode: true,
    };
    this.showGroomingModal = true;
  }

  closePlanModal(flag) {
    this.groomingPetDetail = null;
    this.groomingPlanDetail = null;
    this.showGroomingModal = false;
    this.isChangeClinic = null;
    Utils.enableBodyScroll();
  }

  // Boarding Plan Edit Modal
  openBoardingModal(boardingDetail) {
    this.boardingPetDetail = boardingDetail.pets[0];
    this.boardingPlanDetail = {
      id: boardingDetail.cage_type_id,
      booking_from: boardingDetail.booking_from,
      booking_to: boardingDetail.booking_to,
      inward_time: boardingDetail.inward_time,
      outward_time: boardingDetail.outward_time,
      is_advance_booking_amount: boardingDetail.is_advance_booking_amount,
      advance_payment: boardingDetail.advance_payment,
      cart_id: boardingDetail.id,
      planEditMode: true,
    };
    this.showBoardingModal = true;
  }

  closeBoardingPlanModal(flag) {
    if (flag) {
      this.ngOnInit();
    }
    this.boardingPetDetail = null;
    this.boardingPlanDetail = null;
    this.showBoardingModal = false;
    Utils.enableBodyScroll();
  }

  changeAdvancePayment(plan) {
    this.maximumPaymentFlag = false;
    this.minimumPaymentFlag = false;
    this.updatedAmount = 0;
    this.advanceSelectedPlan = plan;
    this.updatedAmount = plan.advance_payment;
    this.is_advance_amount = true;
    $("#advance_payment_modal").modal("show");
    Utils.disableBodyScroll();
  }

  calculateMinimumAmount(minimumAmount) {
    if (parseFloat(minimumAmount) == 0) {
      this.minimumPaymentFlag = true;
      this.maximumPaymentFlag = false;
      return false;
    } else if (
      parseFloat(minimumAmount) > 0 &&
      minimumAmount <=
        this.advanceSelectedPlan.price - this.advanceSelectedPlan.discount
    ) {
      this.maximumPaymentFlag = false;
      this.minimumPaymentFlag = false;
      return false;
    } else if (parseFloat(minimumAmount) < 0) {
      this.minimumPaymentFlag = true;
      this.maximumPaymentFlag = false;
    } else {
      this.maximumPaymentFlag = true;
      this.minimumPaymentFlag = false;
      return false;
    }
  }

  updateCart() {
    if (
      this.is_advance_amount &&
      (this.updatedAmount == 0 ||
        parseFloat(this.updatedAmount) >
          this.advanceSelectedPlan.price - this.advanceSelectedPlan.discount)
    ) {
      this.calculateMinimumAmount(this.updatedAmount);
      return false;
    }
    let cartDetailsToSend = {};
    cartDetailsToSend["item_type"] = this.advanceSelectedPlan.item_type;
    if (this.advanceSelectedPlan.item_type == "grooming") {
      cartDetailsToSend["grooming_plan_id"] =
        this.advanceSelectedPlan.grooming_plan_id;
      if (this.advanceSelectedPlan.addon_detail.length > 0) {
        let addons = [];
        for (const index in this.advanceSelectedPlan.addon_detail) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.advanceSelectedPlan.addon_detail,
              index
            )
          ) {
            addons.push(this.advanceSelectedPlan.addon_detail[index].id);
          }
        }
        cartDetailsToSend["grooming_addon_ids"] = addons.toString();
      } else {
        cartDetailsToSend["grooming_addon_ids"] = "";
      }
      cartDetailsToSend["groomer_id"] =
        this.advanceSelectedPlan.groomer_detail.id;
      cartDetailsToSend["pet_id"] = this.advanceSelectedPlan.pet_id;
      cartDetailsToSend["pet_type_id"] = this.advanceSelectedPlan.pet_type_id;
      cartDetailsToSend["pet_size_id"] = this.advanceSelectedPlan.pet_size_id;
      cartDetailsToSend["advance_payment"] = this.is_advance_amount
        ? this.updatedAmount
        : 0;
      cartDetailsToSend["is_advance_grooming_amount"] = this.is_advance_amount;
      const dateOfGrooming = Utils.getDateFormat(
        new Date(this.advanceSelectedPlan.groomingDate)
      );
      const groomingDate =
        dateOfGrooming[2] + "-" + dateOfGrooming[1] + "-" + dateOfGrooming[0];
      cartDetailsToSend["schedule_date"] = groomingDate;
      cartDetailsToSend["pet_info"] = {};
    } else {
      const inTimeArray = new Date(this.advanceSelectedPlan.inward_time);
      const outTimeArray = new Date(this.advanceSelectedPlan.outward_time);
      const minTime = new Date();
      minTime.setHours(inTimeArray.getHours());
      minTime.setMinutes(inTimeArray.getMinutes());
      const maxTime = new Date();
      maxTime.setHours(outTimeArray.getHours());
      maxTime.setMinutes(outTimeArray.getMinutes());
      const inwardTime = minTime.toLocaleTimeString("it-IT");
      const outwardTime = maxTime.toLocaleTimeString("it-IT");

      const checkin_date = Utils.getDateFormat(
        new Date(this.advanceSelectedPlan.booking_from)
      );
      const checkInDate =
        checkin_date[2] + "/" + checkin_date[1] + "/" + checkin_date[0];
      const checkout_date = Utils.getDateFormat(
        new Date(this.advanceSelectedPlan.booking_to)
      );
      const checkoutDate =
        checkout_date[2] + "/" + checkout_date[1] + "/" + checkout_date[0];

      cartDetailsToSend["booking_from"] = checkInDate;
      cartDetailsToSend["booking_to"] = checkoutDate;
      cartDetailsToSend["cage_booking_id"] = "";
      cartDetailsToSend["cage_type_id"] = this.advanceSelectedPlan.cage_type_id;
      cartDetailsToSend["inward_time"] = inwardTime;
      cartDetailsToSend["outward_time"] = outwardTime;
      cartDetailsToSend["is_advance_booking_amount"] = this.is_advance_amount;
      cartDetailsToSend["paid_amount"] = this.is_advance_amount
        ? this.updatedAmount
        : 0;
      cartDetailsToSend["pet_type_id"] = this.advanceSelectedPlan.pet_type_id;
      cartDetailsToSend["pets"] = this.advanceSelectedPlan.pets;
    }
    cartDetailsToSend["cart_id"] = this.advanceSelectedPlan.id;

    cartDetailsToSend["out_post_id"] = this.selectedOutpostId;

    this.cartProcess = true;

    this.http.post(API_URLS.UPDATE_CART, cartDetailsToSend, true).subscribe(
      (res) => {
        this.cartProcess = false;
        if (res.type === "success" && res.code === 200) {
          if (res.data) {
            this.cartService.getCartWithApi();
            $("#advance_payment_modal").modal("hide");
            this.closeModal();
          }
        }
      },
      (error) => {
        this.cartProcess = false;
        return false;
      }
    );
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.currentCheckoutItem) {
      this.currentCheckoutItem.unsubscribe();
    }
  }
  onSelect(cart) {
    this.selectedCartItem = cart;

    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }

    this.apiParams = {
      service_id: cart.plan_id,
      service_type:
        cart.item_type === "subscription" ? "subcription" : cart.item_type,
      type: "",
    };

    const modalRef = this.modalService.open(OutpostListModalComponent, {
      size: "xl",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.fromParent = { data: this.apiParams };
    modalRef.componentInstance.closeOutpostModal.subscribe((response) => {
      if (response) {
        this.selectedOutpost = response.title;
        this.selectedOutpostId = response.id;

        this.storeOutpostIdInLocalStorage();
        setTimeout(() => {
          this.outpostModalService.currentOutpost(response);
        }, 100);

        if (
          this.selectedCartItem &&
          this.selectedCartItem.item_type == "grooming"
        ) {
          this.isChangeClinic = true;
          this.openGroomingPlanModal(this.selectedCartItem);
          setTimeout(() => {
            Utils.disableBodyScroll();
          }, 310);
        }
        let extraServices = [];
        extraServices =
          this.selectedCartItem &&
          this.selectedCartItem.extra_services &&
          this.selectedCartItem.extra_services.length &&
          this.selectedCartItem.extra_services.map((item) => item.id);
        let cartDetailsToSend = {
          cart_id: this.selectedCartItem.id,
          grooming_plan_id: this.selectedCartItem.grooming_plan_id,
          grooming_addon_ids: this.selectedCartItem.grooming_addon_ids,
          groomer_id: this.selectedOutpost.groomer_id,
          out_post_id: this.selectedOutpostId,
          item_type: this.selectedCartItem.item_type,
          pet_id: this.selectedCartItem.pet_id,
          pet_type_id: this.selectedCartItem.pet_type_id,
          pet_size_id: this.selectedCartItem.pet_size_id,
          product_ids: this.selectedCartItem.product_ids,
          advance_payment: this.selectedCartItem.advance_payment,
          is_advance_grooming_amount:
            this.selectedCartItem.is_advance_booking_amount,
          schedule_date: this.selectedCartItem.groomingDate,
          pet_info: this.selectedCartItem.pet_info,
          plan_level_id: this.selectedCartItem.plan_level_id,
          extra_services: extraServices && extraServices.toString(),

          // For boarding

          booking_from: this.selectedCartItem.booking_from,
          booking_to: this.selectedCartItem.booking_to,
          cage_type_id: this.selectedCartItem.cage_type_id,
          inward_time: this.selectedCartItem.inward_time,
          outward_time: this.selectedCartItem.outward_time,
          paid_amount: this.selectedCartItem.paid_amount,
          pets: this.selectedCartItem.pets,
        };
        this.http.post(API_URLS.UPDATE_CART, cartDetailsToSend, true).subscribe(
          (res) => {
            this.cartProcess = false;
            if (res.type === "success" && res.code === 200) {
              if (res.data) {
                this.cartService.getCartWithApi();
              }
            }
          },
          (error) => {
            this.cartProcess = false;
            return false;
          }
        );
      }
    });
  }
  storeOutpostIdInLocalStorage() {
    if (localStorage.getItem("selectedOutpostId")) {
      localStorage.removeItem("selectedOutpostId");
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    } else {
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    }
  }

  checkSelectedOutpostItem(index) {
    if (
      this.cartDetails.items[index].out_post_id !== this.selectedOutpostId &&
      this.cartDetails.items[index].item_type !== "product"
    ) {
      this.cartDetails.items[index]["isItemNotRelatedSelectedoutpost"] = true;
      this.isItemNotRelatedSelectedoutpost = true;
    } else {
      this.cartDetails.items[index]["isItemNotRelatedSelectedoutpost"] = false;
      if (!this.isItemNotRelatedSelectedoutpost) {
        this.isItemNotRelatedSelectedoutpost = false;
      }
    }
  }
  closeModal() {
    Utils.enableBodyScroll();
  }
}
